import { render, staticRenderFns } from "./calendar-header.vue?vue&type=template&id=a2a7dd30&"
import script from "./calendar-header.vue?vue&type=script&lang=ts&"
export * from "./calendar-header.vue?vue&type=script&lang=ts&"
import style0 from "./calendar-header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports